import * as React from 'react';
import {connect} from 'react-redux';

import * as ramda from 'ramda';

import {convertToArray} from 'nutshell-core/filter';

import {Checkbox} from 'shells/checkbox/checkbox';

import type {Audience as AudienceFragment} from 'nutshell-graphql-types';

import {makeHandleClickChartToZoom} from '../../../reports/charts/make-handle-click-chart-to-zoom';
import {ReportChart} from '../../../reports/report-chart';
import {
    GAP_SELECT_VALUES_DAY_TO_YEAR,
    getReportDateRanges,
} from '../../../reports/report-constants';
import {ReportDateRangePicker} from '../../../reports/report-date-range-picker';
import type {ReportURLParams} from '../../../reports/report-types';

import type {NutshellState} from '../../../../store';

import type {AudienceMembershipChartParams} from '../audience-utils';
import * as actions from '../audiences-actions';
import * as selectors from '../audiences-selectors';

import {AudienceMembershipReportProvider} from './audience-membership-report-provider';

import styles from './audience-membership-report.module.css';

type OwnProps = {
    audience: AudienceFragment;
    onParamChange: (arg1: any, arg2: boolean) => any;
    onParamPush: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
};

type StateProps = {
    chartBucketCount: number;
};

type DispatchProps = {
    fetchReportData: (arg1: AudienceMembershipChartParams, arg2: any[]) => any;
};

type Props = OwnProps & StateProps & DispatchProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        chartBucketCount: selectors.getCurrentReportChartBucketCount(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch) {
    return {
        // @ts-expect-error
        fetchReportData: (reportParams, filters) => {
            dispatch(actions.requestAudienceMembershipReportData({reportParams, filters}));
        },
    };
}

class AudienceMembershipReportComponent extends React.PureComponent<Props> {
    static defaultProps = {
        urlParams: {
            report: {},
            filter: {},
        },
    };

    componentDidMount() {
        const filters = convertToArray(this.props.urlParams.filter);
        const reportParams = this.props.urlParams.report;

        this.props.fetchReportData(
            {
                ...reportParams,
                reportType: 'membership',
                audienceId: this.props.audience.id,
            },
            filters
        );
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        const {
            urlParams: {report: nextReportParams, filter: nextFilterParams},
        } = nextProps;

        const {
            urlParams: {report: reportParams, filter: filterParams},
        } = this.props;

        const filtersChanged = !ramda.equals(nextFilterParams, filterParams);
        const gapChanged = nextReportParams.gap !== reportParams.gap;

        const universalPropsChanged = filtersChanged;

        if (gapChanged || universalPropsChanged) {
            const nextFilters = convertToArray(nextFilterParams);
            this.props.fetchReportData(
                {
                    ...nextReportParams,
                    reportType: 'membership',
                    audienceId: nextProps.audience.id,
                },
                nextFilters
            );
        }
    }

    render() {
        const reportParams = this.props.urlParams.report || {};

        const currentGapIndex = GAP_SELECT_VALUES_DAY_TO_YEAR.findIndex((gap) => {
            return gap.id === reportParams.gap;
        });

        return (
            <div id='audience-membership-report' className={styles['audience-membership-report']}>
                <ReportDateRangePicker
                    activeFilters={convertToArray(this.props.urlParams.filter)}
                    dateRangeType='period'
                    // @ts-expect-error
                    dateRangeOptions={getReportDateRanges('audienceMembership')}
                    onDateRangeChange={(newFilter) => {
                        this.props.onParamChange(
                            {filter: {...this.props.urlParams.filter, ...newFilter}},
                            true
                        );
                    }}
                />
                <AudienceMembershipReportProvider>
                    <ReportChart
                        hasBorder={true}
                        activeFilters={convertToArray(this.props.urlParams.filter)}
                        // @ts-expect-error
                        onChartClick={makeHandleClickChartToZoom(
                            currentGapIndex,
                            this.props.chartBucketCount,
                            this.props.onParamPush,
                            this.props.urlParams.report.dateRangeType
                        )}
                        height={400}
                        onParamChange={this.props.onParamChange}
                        reportKey='audienceMembership'
                        reportParams={reportParams}
                        xAxisLabel='Date'
                        headerExtraContent={
                            <div className={styles['audience-membership-show-membership-checkbox']}>
                                <Checkbox
                                    label='Show existing subscribers'
                                    checked={this.props.urlParams.filter.includeExisting === '1'}
                                    isLarge={false}
                                    onChange={(newValue) => {
                                        this.props.onParamChange(
                                            {
                                                filter: {
                                                    ...this.props.urlParams.filter,
                                                    includeExisting: newValue ? 1 : 0,
                                                },
                                            },
                                            true
                                        );
                                    }}
                                />
                            </div>
                        }
                    />
                </AudienceMembershipReportProvider>
            </div>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);

// @ts-expect-error
export const AudienceMembershipReport = connector(AudienceMembershipReportComponent);
